import { useBalanceStore } from "./balances";
import { useStoreUtils } from "./utils";

export const useLocaleStore = () => {
    const { getStore } = useStoreUtils();
    const { balanceNames } = useBalanceStore();

    /* Initializes the locale store with short and long format support */
    /* Triggers balance refresh on locale change */
    const init = () => {
        window.Alpine.store("locale", {
            _country: "gb",
            _short: "en",
            _long: "en-US",
            _months: [],
            get short() {
                return this._short;
            },
            set short(v) {
                this._short = v;
                balanceNames.forEach((b) => {
                    const s = getStore(b);
                    s.value = s.value; // for refresh value with current locale.
                });
                getStore("active_bonus").expired_at.value =
                    getStore("active_bonus").expired_at.value; // for refresh value with the current locale.
            },
            get long() {
                return this._long;
            },
            get country() {
                return this._country;
            },
            get months() {
                return this._months;
            },
            set months(m) {
                this._months = m.map((v, i) => ({ name: v, value: i + 1 }));
            },
        });

        const store = getStore("locale");
        store.short = window.appContext?.Player
            ? window.appContext.Player.language
            : (window.appContext?.Config?.locale?.current ?? "en");
        store.months = window.appContext?.Config?.locale?.months ?? [];
    };

    return { init };
};
